import { console } from 'react-redux-app/lib/modules/core/utils';
import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';
import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { actionLoadFiscalNumberRequest } from '../../../fiscalNumber/actions';
import {
  getLoadFiscalNumberError,
  getFiscalNumber,
} from '../../../fiscalNumber/selectors';

import { actionLoadWireRequest } from '../../../wire/actions';
import {
  getLoadWireError,
  getWire,
} from '../../../wire/selectors';

import { actionLoadXCardInitRequest } from '../../../xcard/actions';
import {
  getLoadXCardError,
  getIsXCardInitialized,
} from '../../../xcard/selectors';

import { actionLoadLastPayoutRequest } from '../../actions/lastPayout';
import { getLoadLastPayoutError } from '../../selectors/lastPayout';

import { actionLoadPayoutRequestAvailability } from '../../../payout/actions/payoutRequestAvailability';
import { getLoadPayoutRequestAvailabilityError } from '../../../payout/selectors/payoutRequestAvailability';


export default ({ getState, dispatch }) => (
  function loadPayoutSettingsHandler(nextState, successCallback, errorCallback) {
    Promise.all([
      dispatch(actionLoadFiscalNumberRequest()),
      dispatch(actionLoadWireRequest()),
      dispatch(actionLoadXCardInitRequest()),
      dispatch(actionLoadLastPayoutRequest()),
      dispatch(actionLoadPayoutRequestAvailability()),
    ]).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const loadFiscalNumberError = getLoadFiscalNumberError(getState());
        if (
          loadFiscalNumberError
          && maybeHandleCriticalError(
            nextState.location, loadFiscalNumberError.globalErrors, errorCallback
          )
        ) {
          return;
        }

        const loadWireError = getLoadWireError(getState());
        if (
          loadWireError
          && maybeHandleCriticalError(
            nextState.location, loadWireError.globalErrors, errorCallback
          )
        ) {
          return;
        }

        const loadXCardError = getLoadXCardError(getState());
        if (
          loadXCardError
          && maybeHandleCriticalError(
            nextState.location, loadXCardError.globalErrors, errorCallback
          )
        ) {
          return;
        }

        const loadLastPayoutError = getLoadLastPayoutError(getState());
        if (
          loadLastPayoutError
          && maybeHandleCriticalError(
            nextState.location, loadLastPayoutError.globalErrors, errorCallback
          )
        ) {
          return;
        }

        const loadPayoutRequestAvailabilityError = getLoadPayoutRequestAvailabilityError(
          getState()
        );
        if (
          loadPayoutRequestAvailabilityError
          && maybeHandleCriticalError(
            nextState.location, loadPayoutRequestAvailabilityError.globalErrors, errorCallback
          )
        ) {
          return;
        }

        if (
          getFiscalNumber(getState())
          && getWire(getState())
          && getIsXCardInitialized(getState())
        ) {
          successCallback();
          return;
        }

        console.consoleError(
          `loadPayoutSettingsHandler. Unable to get payout settings. Make redirect to ${INTERNAL_ERROR_URI}`
        );
        errorCallback(INTERNAL_ERROR_URI);
      }
    ).catch(error => {
      console.consoleError('loadPayoutSettingsHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
